module.exports = __webpack_public_path__ + "img/w3_circle_right_light.9dd709ea.png";